"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactComponents = require("@ui-propulsion/react-components");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography;
  var fontFamilyRegular = typography.fontFamilyRegular,
    fontFamilyBold = typography.fontFamilyBold,
    pxToRem = typography.pxToRem;
  return {
    root: {
      fontFamily: fontFamilyRegular,
      color: palette.denim[500]
    },
    title: _objectSpread(_objectSpread({}, typography.title2), {}, {
      fontSize: pxToRem(18),
      fontWeight: 'bold',
      lineHeight: pxToRem(22),
      margin: "".concat(pxToRem(24), " 0 ").concat(pxToRem(20), " 0")
    })
  };
}, {
  name: 'PlaidVerifyDetailsContainer'
});
exports.useStyles = useStyles;
